import { createSelector } from 'reselect';

export const getScanState = (state) => state.scans;

export const getProcessing = createSelector(getScanState, (scans) => scans.processing);
export const getProcessed = createSelector(getScanState, (scans) => scans.processed);
export const getError = createSelector(getScanState, (scans) => scans.error);
export const getCurrentScans = createSelector(getScanState, (scans) => scans.scans);
export const getCurrentScan = createSelector(getScanState, (scans) => scans.scan);
